import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';
import { siteInfo } from '../data/siteData';

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="w-full px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <div className="mb-4">
              <img 
                src="/logo-white.png" 
                alt="LookWell Gents Salon Logo" 
                className="h-14 w-auto object-contain"
              />
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Dubai's premier gents salon delivering excellence in grooming since establishment. Your confidence is our success.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-amber-500">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-gray-400 hover:text-amber-500 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-amber-500 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-amber-500 transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-amber-500">Our Services</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/services/hair-care" className="text-gray-400 hover:text-amber-500 transition-colors">
                  Hair Care & Styling
                </Link>
              </li>
              <li>
                <Link to="/services/face-care" className="text-gray-400 hover:text-amber-500 transition-colors">
                  Face Care & Treatments
                </Link>
              </li>
              <li>
                <Link to="/services/beard-care" className="text-gray-400 hover:text-amber-500 transition-colors">
                  Beard Grooming
                </Link>
              </li>
              <li>
                <Link to="/services/relaxation" className="text-gray-400 hover:text-amber-500 transition-colors">
                  Relaxation & Massage
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-amber-500">Contact Us</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <MapPin size={18} className="text-amber-500 flex-shrink-0 mt-1" />
                <span className="text-gray-400">
                  {siteInfo.address.line1}<br />
                  {siteInfo.address.line2}
                </span>
              </li>
              <li>
                <a
                  href={`tel:${siteInfo.phone.replace(/\s/g, '')}`}
                  className="flex items-center gap-2 text-gray-400 hover:text-amber-500 transition-colors"
                >
                  <Phone size={18} className="text-amber-500" />
                  {siteInfo.phone}
                </a>
              </li>
            </ul>

            {/* Social Media */}
            <div className="flex gap-3 mt-4">
              <a
                href={siteInfo.social.facebook}
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-amber-500 transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Facebook size={18} />
              </a>
              <a
                href={siteInfo.social.instagram}
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-amber-500 transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Instagram size={18} />
              </a>
              <a
                href={siteInfo.social.twitter}
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-amber-500 transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Twitter size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm mb-3">
            © {new Date().getFullYear()} LookWell Gents Salon. All rights reserved. | Designed for excellence in Dubai, UAE
          </p>
          <div className="flex justify-center gap-6 text-sm">
            <Link to="/privacy-policy" className="text-gray-400 hover:text-amber-500 transition-colors">
              Privacy Policy
            </Link>
            <span className="text-gray-600">|</span>
            <Link to="/terms-conditions" className="text-gray-400 hover:text-amber-500 transition-colors">
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
